import { CustomerType } from "@/enums/CustomerType";

export class PriceExtensions {
  static getPriceFormattedByCustomerType = (privatePrice: string, businessPrice: string): string => {
    if (window.customerType == CustomerType.Private) {
      return privatePrice;
    }
    return businessPrice;
  };
}
